import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { AlertCircle } from 'lucide-react';
import { Carousel } from '../ui/Carousel';
const painPoints = [{
  title: 'Cada día es una batalla',
  desc: 'Las tareas, el baño, la mochila, dormir. Todo termina en pelea o en lágrimas — de él o tuyas.'
}, {
  title: 'Nada dura más de tres días',
  desc: 'Probás estrategias, funcionan un poco y después vuelve todo al mismo lugar.'
}, {
  title: 'El colegio no te escucha',
  desc: "Te dicen que 'hay que ponerle más límites' y te mandan notas que no saben cómo responder."
}, {
  title: 'La obra social te da vueltas',
  desc: 'Pedís cobertura y te dicen que no, que esperes, que falta un papel. Siempre falta algo.'
}, {
  title: 'Perdiste la paciencia y te sentís culpable',
  desc: 'Sabés que no es su culpa. Pero también sabés que no podés más. Y esa combinación agota.'
}, {
  title: 'Cada crisis te deja sin recursos',
  desc: 'Cuando explota no sabés qué decir, qué hacer ni cómo reparar después.'
}, {
  title: 'No sabés si lo estás haciendo bien',
  desc: 'Médicos, psicopedagogas, maestras — todos te dicen algo distinto y ninguno te da un plan concreto.'
}, {
  title: 'Fin de mes sin cambios reales',
  desc: 'Horas de consultas, recursos sueltos de Instagram y la sensación de que nada termina de funcionar.'
}];
export function PainPoints() {
  return <section className="py-12 md:py-20 bg-[#FBF7F0] overflow-hidden" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <SectionHeader title="¿TE PASA ESTO?" subtitle="Si tenés un hijo con TDAH en Argentina, esto te suena familiar:" data-id="element-168" />

        <div className="mb-8 md:mb-14" data-id="element-169">
          <Carousel itemWidthClass="w-[78%] sm:w-[300px]" ariaLabel="Situaciones frecuentes con TDAH" data-id="element-170">
            {painPoints.map((point, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.96
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} whileHover={{
            y: -4
          }} className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-red-100 w-full" data-id="element-171">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-red-50 rounded-full flex items-center justify-center mb-3 md:mb-4" data-id="element-172">
                  <AlertCircle className="text-[#E76F51] w-4 h-4 md:w-5 md:h-5" data-id="element-173" />
                </div>
                <h3 className="font-bold text-[#1E2A4A] text-base md:text-lg mb-2" data-id="element-174">
                  {point.title}
                </h3>
                <p className="text-[#1E2A4A]/70 text-sm leading-relaxed" data-id="element-175">
                  {point.desc}
                </p>
              </motion.div>)}
          </Carousel>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center px-4" data-id="element-176">
          <p className="text-xl md:text-3xl font-bold text-[#1E2A4A]" data-id="element-177">
            ¿Cuántos meses más vas a manejarte sin un sistema que{' '}
            <span className="text-[#E76F51] underline decoration-4 underline-offset-4" data-id="element-178">
              realmente funcione
            </span>
            ?
          </p>
        </motion.div>
      </div>
    </section>;
}